<template>
  <div>
    <vxe-grid
      ref="grid"
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <b-input-group size="sm">
          <b-button
            size="sm"
            variant="outline-success"
            @click="
              $emit('openEditFormDialog', {
                type: 'add',
              })
            "
            v-if="allow('A')"
            :disabled="disabled"
          >
            <b-icon-plus></b-icon-plus>{{ $l("INDEX.btn_add") || "新增" }}
          </b-button>
        </b-input-group>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l("INDEX.table_label_no_data") || "暂无数据！" }}
          </p>
        </div>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="allow('M')"
            v-show="!disabled"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  params: { code: row.purchasePackageExpenseCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="allow('D')"
            v-show="!disabled"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del({ code: row.purchasePackageExpenseCode })"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from "./table-columns"
export default {
  props: {
    disabled: Boolean,
    tableData: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => this.$emit("reload"),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del({ code }) {
      this.$confirm(
        this.$l("INDEX.tips_delete") || "是否要删除该记录？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$api
            .purchasePackageExpenseDelApi({ purchasePackageExpenseCode: code })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
                type: "success",
              })
              this.$emit("reload")
            })
        })
        .catch(() => {})
    },
  },
}
</script>
